import logo from './logo.png'

export const theme = {
    color: {
      primary: "#003366",
      primaryHover: "#002d5b",
    },
    logoImage: logo,
    backend: "https://ihk-wab.epaper-publishing-one.de/",
    header: {
      customer: "",
      title: "IHK-Zeitschrift WAB",
      lineHeader: true,
    },
    directory: "/kiosk",
    info: [{
      text: 'Impressum',
      link: 'https://www.ihk.de/ulm/servicemarken/ueber-uns/impressum-haftung-datenschutz/impressum-1606264'
    },
    {
    text: 'Datenschutz',
    link: 'https://www.ihk.de/ulm/datenschutz-1606258'
  }],
  };